'use client';

import React__default, { useRef, useState, useEffect } from 'react';
import { ScorePercentWrapper, CircleItem, LabelPercent } from './CircleProgressBar.css.js';
import { DEFAULT_OPTIONS } from './constants.js';
import { deepMerge } from '../Utils/helpers.js';
import '../_virtual/_tslib.js';
import 'react-dom';
import '../hooks/useMakeSearchable/types.js';
import '../Utils/constants.js';
import '../services/resumes/types.js';
import useElementOnScreen from '../Utils/hooks/UseElementOnScreen/index.js';
import CountUp from '../TextCountUp/index.js';
import { LabelExtend } from '../AICircleProgressBar/AICircleProgressBar.css.js';

var circlePercent = 100; // Total percent of a circle
var circleRadius = 360; // Total radius of a circle
var CircleProgressBar = function (props) {
    var options = props.options;
    var mergedOptions = deepMerge(DEFAULT_OPTIONS, options);
    var divRef = useRef(null);
    var _a = useState(0), percent = _a[0], setPercent = _a[1];
    var isElementOnScreen = useElementOnScreen({
        target: divRef,
        options: {
            rootMargin: '0px 0px 0px 0px'
        }
    })[0];
    useEffect(function () {
        if (!isElementOnScreen) {
            return;
        }
        setTimeout(function () { return setPercent(props.percent > circlePercent ? circlePercent : props.percent); }, 500);
    }, [props.percent, isElementOnScreen]);
    var radius = mergedOptions.radius / 2 - mergedOptions.strokeWidth / 2;
    // Total Perimeter in pixel of circle
    var perimeter = Math.PI * 2 * radius;
    // Convert StrokeWidth into radius
    var strokeRadius = (mergedOptions.strokeWidth * circleRadius) / perimeter;
    // Convert SegmentSpace into radius
    var segmentSpacing = (mergedOptions.segmentSpace * circleRadius) / perimeter;
    // Convert percentage to radius
    // Minus 90 deg (CSS Rotation)
    var segmentRotation = Math.round((mergedOptions.segmentAtPercent * circleRadius) / circlePercent) - 90 + strokeRadius + segmentSpacing;
    var segmentStrokeWidth = mergedOptions.strokeWidth;
    var currentPercent = percent;
    var remainPercent = 0;
    if (percent > mergedOptions.segmentAtPercent && mergedOptions.isShowSegment) {
        remainPercent = percent - mergedOptions.segmentAtPercent;
        currentPercent = mergedOptions.segmentAtPercent;
    }
    else if (percent < mergedOptions.segmentAtPercent) {
        remainPercent = 0;
    }
    var strokeDashoffset = ((circlePercent - currentPercent) / circlePercent) * perimeter;
    var segmentDashOffset = ((circlePercent - mergedOptions.segmentAtPercent) / circlePercent) * perimeter -
        mergedOptions.segmentSpace * 2 -
        mergedOptions.strokeWidth * 2;
    var totalRemainPercent = circlePercent - mergedOptions.segmentAtPercent;
    var remainDashoffset = (remainPercent * segmentDashOffset) / totalRemainPercent;
    if (remainPercent <= 0) {
        remainDashoffset = segmentDashOffset;
    }
    if (percent <= mergedOptions.segmentAtPercent) {
        remainDashoffset = 0;
    }
    if (remainDashoffset <= 0) {
        segmentStrokeWidth = 0;
    }
    return (React__default.createElement(ScorePercentWrapper, { ref: divRef, diameter: mergedOptions.radius },
        React__default.createElement("svg", { viewBox: "-".concat(mergedOptions.radius / 2, " -").concat(mergedOptions.radius / 2, " ").concat(mergedOptions.radius, " ").concat(mergedOptions.radius), role: 'presentation' },
            mergedOptions.isUsingGradient ? (React__default.createElement("defs", null,
                React__default.createElement("linearGradient", { id: 'paint0_linear_36250_774849', x1: '-198.5', y1: '-95', x2: '-119.5', y2: '160.5', gradientUnits: 'userSpaceOnUse' },
                    React__default.createElement("stop", { offset: '0.0230633', stopColor: '#B900F6' }),
                    React__default.createElement("stop", { offset: '0.375817', stopColor: '#DC1EAF' }),
                    React__default.createElement("stop", { offset: '0.632849', stopColor: '#FF6200' }),
                    React__default.createElement("stop", { offset: '1', stopColor: '#FDB92E' })))) : null,
            React__default.createElement(CircleItem, { r: radius, cx: '0', cy: '0', strokeLinecap: 'round', strokeWidth: mergedOptions.strokeWidth, perimeter: perimeter, strokeDashoffset: 0, stroke: '#f4f4f7', style: {
                    strokeDasharray: mergedOptions.isShowSegment
                        ? "".concat(perimeter * (mergedOptions.segmentAtPercent / circlePercent), "px, ").concat(perimeter, "px")
                        : "".concat(perimeter, "px, ").concat(perimeter, "px")
                }, duration: mergedOptions.duration }),
            React__default.createElement(CircleItem, { r: radius, cx: '0', cy: '0', 
                // stroke={mergedOptions.color}
                stroke: mergedOptions.isUsingGradient ? 'url(#paint0_linear_36250_774849)' : mergedOptions.color, strokeLinecap: 'round', strokeWidth: mergedOptions.strokeWidth, opacity: '1', perimeter: perimeter, strokeDashoffset: strokeDashoffset, duration: mergedOptions.duration }),
            mergedOptions.isShowSegment ? (React__default.createElement(CircleItem, { r: radius, cx: '0', cy: '0', strokeLinecap: 'round', strokeWidth: mergedOptions.strokeWidth, perimeter: perimeter, stroke: '#f4f4f7', style: {
                    strokeDasharray: "".concat(segmentDashOffset, "px, ").concat(perimeter, "px"),
                    transform: "rotate(".concat(segmentRotation, "deg)")
                }, duration: mergedOptions.duration, strokeDashoffset: 0, opacity: 1 })) : null,
            mergedOptions.isShowSegment ? (React__default.createElement(CircleItem, { r: radius, cx: '0', cy: '0', stroke: mergedOptions.color, strokeLinecap: 'round', strokeWidth: segmentStrokeWidth, opacity: '1', perimeter: perimeter, strokeDashoffset: 0, customStrokeDashArray: "".concat(remainDashoffset, "px, ").concat(perimeter, "px"), style: {
                    transform: "rotate(".concat(segmentRotation, "deg)")
                }, duration: mergedOptions.duration })) : null),
        React__default.createElement(LabelPercent, { color: mergedOptions.isUsingGradient ? '#343434' : mergedOptions.color, sizes: mergedOptions.radius, label: mergedOptions.label },
            React__default.createElement(CountUp, { start: 0, end: percent, duration: mergedOptions.duration * (mergedOptions.isShowSegment ? 2 : 1) }),
            "%",
            mergedOptions.label.extend ? (React__default.createElement(React__default.Fragment, null,
                React__default.createElement("br", null),
                React__default.createElement(LabelExtend, null, mergedOptions.label.extend))) : null)));
};

export { CircleProgressBar as default };
//# sourceMappingURL=index.js.map
